import type { Status } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-details.tsx';
import type { StatusPickerOption } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/picker-options.tsx';

export const transformStatusToSelectOption = ({
	name,
	id,
	category,
}: Status): StatusPickerOption => ({
	label: name,
	value: id,
	category,
});

export const transformOptionToStatusId = ({ value }: StatusPickerOption): string => value;
